// Régénéré à chaque déploiement — permet de vérifier qu'un joueur a bien
// la dernière version (cf. incident cache navigateur du 23/10/2026).
export const BUILD_ID = '31/10/2026 16h18 GMT';
